/**
 * resolveMovimientoPuntoCajaNombre.ts — Etiqueta visible del punto de caja de un movimiento.
 */

import type { MovimientoCaja } from "../types/caja.types";
import {
  nombrePuntoFromCatalogLocal,
  resolvePuntoCajaDisplayLabel,
} from "./cajaSessionLocal";
import { readCierresHistorial } from "./sesionCerradaHelper";

const CAJA_EN_MOTIVO_RE =
  /(?:Gasto operativo|Retiro parcial|Fondo adicional)\s+(Caja(?:\s+[\p{L}0-9]+)?)/iu;

/** Resuelve el nombre del punto de caja aunque el movimiento no lo tenga persistido. */
export function resolveMovimientoPuntoCajaNombre(
  mov: MovimientoCaja,
): string | null {
  const direct = mov.puntoCajaNombre?.trim();
  if (direct) return direct;

  const puntoId = mov.puntoCajaId?.trim();
  if (puntoId) {
    const fromCatalog =
      resolvePuntoCajaDisplayLabel(puntoId) ||
      nombrePuntoFromCatalogLocal(puntoId);
    if (fromCatalog?.trim() && fromCatalog !== puntoId) {
      return fromCatalog.trim();
    }
  }

  const sesionId = mov.sesionId?.trim();
  if (sesionId) {
    const cierre = readCierresHistorial().find((c) => c.sesionId === sesionId);
    if (cierre?.puntoCajaNombre?.trim()) return cierre.puntoCajaNombre.trim();
    if (cierre?.puntoCajaId) {
      const label = resolvePuntoCajaDisplayLabel(cierre.puntoCajaId);
      if (label?.trim()) return label.trim();
    }
  }

  const fromMotivo = mov.motivo?.match(CAJA_EN_MOTIVO_RE)?.[1]?.trim();
  if (fromMotivo) return fromMotivo;

  return null;
}
